import React, { Component } from 'react';
import { connect } from 'react-redux';
import { signIn, signInWithGoogle, signInWithPhone, signOut, checkProvisioning } from '../../store/actions/authActions';
import { Link, Redirect } from 'react-router-dom';
import logo from "assets/img/logo-small.png";
import { firebaseConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import Hidden from "@material-ui/core/Hidden";
    
class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    }

    
  }
  
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.signIn(this.state)
  }

  loginWithGoogle = (e) => {
    e.preventDefault();
    this.props.signInWithGoogle();
  }

  loginWithPhone = (e) => {
    e.preventDefault();
    this.props.signInWithPhone();
  }
  render() {
    const { authError, auth, provisionChecked, provisioned, user } = this.props;

    
    if (auth.uid && provisioned) return <Redirect to='/' /> 
    if (auth.uid && !provisionChecked) {
      this.props.checkProvisioning(user);
      return <div>Checking user permissions.</div>
    } else if (auth.uid && provisionChecked && !provisioned) {
      return <div>This user is not provisioned to use the dashboard application.<button className="btn green lighten-1 z-depth-0 center" style={{margin: "20px"}} onClick={this.props.signOut}>Sign Out</button></div>
    }
    return (
      <div className="grey lighten-1" style={{position: "absolute", top: 0, left: 0, width:"100%", height:"100%"}}>
      <div className="container">
        
        <form className="grey lighten-2" onSubmit={this.handleSubmit}>
        <div style={{display:"flex",flexDirection: "row" }}>
        <img src={logo}/> <p className="grey-text text-darken-3">CONSTRUWISE</p>
        </div>
          <h5 className="grey-text text-darken-3">Sign In</h5>
          <div className="input-field">
            <label htmlFor="email">Email</label>
            <input type="email" id='email' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label htmlFor="password">Password</label>
            <input type="password" id='password' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <button className="btn green lighten-1 z-depth-0">Login</button>
            <div className="right" style={{justifyContent: "center", alignItems: "center", display:"flex",flexDirection: "row" }}>
             <span><Hidden xsDown implementation="css">Not a Construwise customer?&nbsp;&nbsp;</Hidden></span><Link to="/signup"><button className="btn green lighten-1 z-depth-0">Sign Up</button></Link>
            </div>
            </div>
            <div className="center red-text">
              { authError ? <p>{authError}</p> : null }
            </div>
          
          
            <div className="center">
        <button className="btn green lighten-1 z-depth-0 center" style={{width: "200px", margin: "20px"}} onClick={this.loginWithGoogle}>Login with Google</button>
        
        <button className="btn green lighten-1 z-depth-0 center" style={{width: "200px", margin: "20px"}} onClick={this.loginWithPhone}>Login by Phone</button>
        <div id="recaptcha-container"></div>
        </div>
        </form>
        
      </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const user = state.firebase.data.users === undefined ? null : state.firebase.data.users[state.firebase.auth.uid];
  return{
    authError: state.auth.authError,
    auth: state.firebase.auth,
    partialAuth: state.auth.partialAuth,
    provisionChecked: state.auth.provisionChecked,
    provisioned: state.auth.provisioned,
    user: user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds)),
    signOut: () => dispatch(signOut()),
    signInWithGoogle: () => dispatch(signInWithGoogle()),
    signInWithPhone: () => dispatch(signInWithPhone()),
    checkProvisioning: (user) => dispatch(checkProvisioning(user))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
    firebaseConnect([
      {path: 'users'}
    ]))(SignIn)




// WEBPACK FOOTER //
// ./src/components/auth/SignIn.js